export const isLightColor = (hex) => {
  const m = /^#([0-9a-f]{6})$/i.exec(hex || "");
  if (!m) return true;
  const n = parseInt(m[1], 16);
  const [r, g, b] = [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.65;
};

export const tileTheme = (color) => {
  if (!color) return null;
  const light = isLightColor(color);
  return {
    style: { backgroundColor: color },
    iconBg: light ? "bg-black/5" : "bg-white/25",
    icon: light ? "text-[#12234A]" : "text-white",
    label: light ? "text-[#12234A]" : "text-white",
    sub: light ? "text-slate-600" : "text-white/85",
  };
};

const toHsl = (hex) => {
  const n = parseInt(hex.slice(1), 16);
  const [r, g, b] = [(n >> 16) & 255, (n >> 8) & 255, n & 255].map((v) => v / 255);
  const max = Math.max(r, g, b), min = Math.min(r, g, b), l = (max + min) / 2;
  if (max === min) return [0, 0, l];
  const d = max - min, s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
  const h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
  return [h * 60, s, l];
};

const fromHsl = (h, s, l) => {
  const k = (n) => (n + h / 30) % 12, a = s * Math.min(l, 1 - l);
  const f = (n) => Math.round(255 * (l - a * Math.max(-1, Math.min(k(n) - 3, 9 - k(n), 1))));
  return `#${[f(0), f(8), f(4)].map((v) => v.toString(16).padStart(2, "0")).join("")}`.toUpperCase();
};

export const spreadHues = (hex, count) => {
  const [h, s, l] = toHsl(hex);
  const sat = Math.max(s, 0.45);
  return Array.from({ length: count }, (_, i) => fromHsl((h + (i * 360) / count) % 360, sat, l));
};

export const TILE_PRESETS = {
  Bright: ["#F5551E", "#E11D74", "#7C3AED", "#2563EB", "#0891B2", "#059669", "#65A30D", "#D97706", "#DC2626", "#DB2777"],
  Pastel: ["#FFD8C7", "#FBCFE8", "#DDD6FE", "#BFDBFE", "#A5F3FC", "#A7F3D0", "#D9F99D", "#FDE68A", "#FECACA", "#F5D0FE"],
  "Brand orange": ["#F5551E", "#F76B38", "#F98352", "#E04812", "#C93E0E", "#1C3166", "#12234A", "#F5551E", "#E04812", "#12234A"],
  Rainbow: ["#EF4444", "#F97316", "#F59E0B", "#84CC16", "#10B981", "#06B6D4", "#3B82F6", "#6366F1", "#A855F7", "#EC4899"],
};

export const HOLIDAY_PRESETS = {
  Christmas: ["#C8102E", "#0F7B3F", "#C8102E", "#0F7B3F", "#C8102E", "#0F7B3F", "#C8102E", "#0F7B3F", "#C8102E", "#0F7B3F"],
  Halloween: ["#F97316", "#6B21A8", "#111827", "#F97316", "#6B21A8", "#111827", "#F97316", "#6B21A8", "#111827", "#F97316"],
  "Canada Day": ["#D80621", "#FFFFFF", "#D80621", "#FFFFFF", "#D80621", "#FFFFFF", "#D80621", "#FFFFFF", "#D80621", "#FFFFFF"],
  "Valentine's": ["#E11D48", "#FB7185", "#BE123C", "#F9A8D4", "#E11D48", "#FB7185", "#BE123C", "#F9A8D4", "#E11D48", "#FB7185"],
  Easter: ["#FDE68A", "#BBF7D0", "#C7D2FE", "#FBCFE8", "#BAE6FD", "#FDE68A", "#BBF7D0", "#C7D2FE", "#FBCFE8", "#BAE6FD"],
};
